import React from "react";
import * as S from "./scopeDashboard.styles";

export const FY_VIEW = "fy";
export const COMPARISON_VIEW = "comparison";

/** Financial Year View / Comparison View segmented toggle. */
export const ViewToggle = ({ viewMode, onChange }) => (
  <S.Toggle role="tablist" aria-label="Dashboard view">
    <S.ToggleBtn
      type="button"
      role="tab"
      aria-selected={viewMode === FY_VIEW}
      $active={viewMode === FY_VIEW}
      onClick={() => onChange(FY_VIEW)}
    >
      Financial Year View
    </S.ToggleBtn>
    <S.ToggleBtn
      type="button"
      role="tab"
      aria-selected={viewMode === COMPARISON_VIEW}
      $active={viewMode === COMPARISON_VIEW}
      onClick={() => onChange(COMPARISON_VIEW)}
    >
      Comparison View
    </S.ToggleBtn>
  </S.Toggle>
);

export default ViewToggle;
